module.exports = "<app-navbar></app-navbar>\n<app-sidebar></app-sidebar>\n<div id=\"canvasDiv\">\n  <canvas id=\"canvas\"></canvas>\n</div>\n"